import { create } from 'zustand'

export const useNavigationGuardStore = create((set) => ({
    isDirtyForm: false,
    setIsDirtyForm: (value) => set(() => ({ isDirtyForm: value })),
    resetDirtyForm: () => set(() => ({ isDirtyForm: false })),
}))

export const useEditingStore = create((set) => ({
    editingField: null,
    setEditingField: (fieldName) => set({ editingField: fieldName }),
    clearEditingField: () => set({ editingField: null })
}))

export const useSignalFilterStore = create((set) => ({
    filters: {},

    // Action to update a specific filter value
    updateFilter: (key, value) =>
        set((state) => ({
            filters: {
                ...state.filters,
                [key]: value,
            },
        })),

    setFilters: (filters) =>
        set(() => ({
            filters,
        })),


    // Action to reset all filters
    resetFilters: () =>
        set(() => ({
            filters: {},
        })),
}))

export const useNewsFilterStore = create((set) => ({
    filters: {},

    // Action to update a specific filter value
    updateFilter: (key, value) =>
        set((state) => {
            const updatedFilters = {
                ...state.filters,
                [key]: value,
            }

            // Remove keys with `false` values
            const filteredFilters = Object.fromEntries(
                Object.entries(updatedFilters).filter(([_, v]) => v !== false)
            )

            return { filters: filteredFilters }
        }),

    setFilters: (filters) =>
        set(() => ({
            filters,
        })),


    // Action to reset all filters
    resetFilters: () =>
        set(() => ({
            filters: {},
        })),
}))

export const useRssFeedStore = create((set) => ({
    item: null,
    setRssFeedItem: (item) => set({ item }),
    clearRssFeedItem: () => set({ item: null })
}))